import React from "react";
import { Document, Page, Text, View, StyleSheet, PDFViewer, PDFDownloadLink, Font, Image  } from '@react-pdf/renderer';
import Prompt from "../assets/fonts/Sarabun/Prompt-Bold.ttf";
import { colors } from "../configs";

const { white } = colors;

Font.register(
  {
    family: "Prompt",
    src: Prompt,
  }
);

function LargeHorizontalNoPro({
    data
}) {

  return    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
                {data.map((item,index)=>{
                    const { name, unit, price, barcode, barcodeImage } = item;
                    return <Page size="A4" orientation="landscape" key={index} >
                            <View style={{width:"100%",alignItems:'center', borderWidth:0.5, flex:1 }} >
                                <View style={{backgroundColor:'#de2702', width:'100%' , alignItems:'center', paddingLeft:10, paddingRight:10, color:white, height:150 }} >
                                {/* <View style={{backgroundColor:'#de2702', width:'100%' , alignItems:'center', paddingLeft:10, paddingRight:10, color:white, height:190 }} > */}
                                    <Text style={{ fontSize:55, margin:10, marginTop:-10 }}  >{name} </Text>
                                </View>
                                <View style={{flexDirection:'row',alignItems:'flex-end', marginTop:-5, justifyContent:'space-around', width:'100%' }} >
                                    <Text style={{ fontSize:35 }}>({unit})</Text>
                                    <Text style={{ fontSize:200, marginBottom:-7, paddingBottom:0 }} >{price}</Text>
                                    <Text style={{ fontSize:50 }}>บาท</Text>
                                </View>
                                <Text style={{ fontSize:30 }} >{barcode}</Text>
                                {barcodeImage && <Image style={{ width:'450px'}} src={barcodeImage} />}
                            </View>
                        </Page>
                })}

            </Document>
}

export default LargeHorizontalNoPro;
